module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    attrs: {
      "name": "quote"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "https://contattafiles.s3-us-west-1.amazonaws.com/tnt8888/hIf7gIIFd6jb9AY/q.png",
      "alt": "Question Image"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Today's Quote")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todayQuote.quote),
      expression: "todayQuote.quote"
    }],
    attrs: {
      "id": "Quote",
      "maxlength": "17",
      "name": "quote",
      "Placeholder": "enter quote here"
    },
    domProps: {
      "value": (_vm.todayQuote.quote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.todayQuote, "quote", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', [(!_vm.isQuoteExist) ? _c('button', {
    staticClass: "btn btn--primary",
    on: {
      "click": function($event) {
        return _vm.Save()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.isQuoteExist) ? _c('button', {
    staticClass: "btn btn--primary",
    on: {
      "click": function($event) {
        return _vm.Update()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da735e7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/Quote.vue
// module id = 1756
// module chunks = 2